import React from "react";
import { Link } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import { StyledIconButton, StyledTextButton } from "./styles";
import { PlusIcon } from "../../assets/icons";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Props } from "./interfaces";

export const AddEditButton = ({
  title,
  effect,
  onClick,
  children,
  asLink = false,
  linkText,
  linkRoute,
  buttonText,
  disabled = false,
  customStyle,
  useMiniPlusButton = false,
}: Props) => {
  return (
    <>
      {asLink && linkRoute ? (
        <Link to={linkRoute}>{linkText}</Link>
      ) : buttonText ? (
        <StyledTextButton
          style={{ ...customStyle }}
          onClick={onClick}
          disabled={disabled}
        >
          {buttonText}
        </StyledTextButton>
      ) : (
        <StyledIconButton
          effect={effect}
          onClick={onClick}
          title={title}
          disabled={disabled}
          style={{ ...customStyle }}
          asLink={asLink}
          isMini={useMiniPlusButton}
        >
          {!!children ? children : effect === "add" ? <PlusIcon title="Add" /> : <FontAwesomeIcon icon={faPencilAlt} />}
        </StyledIconButton>
      )}
    </>
  );
};
export default AddEditButton;
